(function () {
  'use strict';
  var boxes = document.querySelectorAll('.ew-delivery');
  if (!boxes.length) return;
  var DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var fmt = function (d, noMonth) { return DAYS[d.getDay()] + ' ' + d.getDate() + (noMonth ? '' : ' ' + MONTHS[d.getMonth()]); };
  var addWorkingDays = function (from, n) { var d = new Date(from.getTime()); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; };
  var today = new Date();
  boxes.forEach(function (box) {
    var ship = addWorkingDays(today, Number(box.dataset.shipDays || 1));
    var min = addWorkingDays(ship, Number(box.dataset.deliverMin || 2));
    var max = addWorkingDays(ship, Number(box.dataset.deliverMax || 4));
    var set = function (key, text) { var el = box.querySelector('[data-d="' + key + '"]'); if (el) el.textContent = text; };
    set('order', fmt(today)); set('ship', fmt(ship));
    set('deliver', fmt(min, min.getMonth() === max.getMonth()) + ' – ' + fmt(max));
  });
})();
